import { createSelector } from '@ngrx/store';

import { selectAllDepartamentos } from '../entity-departamentos/entity-departamentos.selectors';
import {
  selectAllDireccionesGeograficaIDE,
  selectDireccionesGeograficaIDEState
} from '../entity-direcciones-geografica-ide/entity-direcciones-geografica-ide.selectors';
import { selectAllLocalidades } from '../entity-localidades/entity-localidades.selectors';
import { selectAllPaises } from '../entity-paises/entity-paises.selectors';
import { createDireccionGeograficaSet } from './direcciones-geograficas.model';
import {
  selectDireccionesGeograficaIDEExacta,
  selectDireccionesGeograficaIDEExactaState
} from '../entity-direcciones-geografica-ide-exacta/entity-direcciones-geografica-ide.selectors';
import { selectAllLocalidadesIDE } from '../entity-localidades-ide/entity-localidades-ide.selectors';

export const selectDireccionGeograficaInitialData = createSelector(
  selectAllPaises,
  selectAllDepartamentos,
  selectAllLocalidades,
  selectAllDireccionesGeograficaIDE,
  selectDireccionesGeograficaIDEExacta,
  (paises, departamentos, localidades, direccionesIDE, direccionExacta) => {
    return createDireccionGeograficaSet({
      paises: paises,
      departamentos: departamentos,
      localidades: localidades,
      direccionesGeograficasIDE: direccionesIDE,
      direccionGeograficaIDEExacta: direccionExacta
    });
  }
);

export const selectDireccionGeograficaInitialDataByMap = (mapa: string) =>
  createSelector(
    selectAllPaises,
    selectAllDepartamentos,
    selectAllLocalidades,
    selectAllLocalidadesIDE,
    selectDireccionesGeograficaIDEExacta,
    selectDireccionesGeograficaIDEState,
    selectDireccionesGeograficaIDEExactaState,
    (
      paises,
      departamentos,
      localidades,
      localidadesIDE,
      direccionExacta,
      stateMap,
      stateExacta
    ) => {
      const dirIDE = stateMap?.resultadosPorMapa?.[mapa] || null;
      const dirExacta = stateExacta.mapa == mapa ? direccionExacta : null;
      return createDireccionGeograficaSet({
        paises: paises,
        departamentos: departamentos,
        localidades: localidades,
        localidadesIDE: localidadesIDE,
        direccionesGeograficasIDE: dirIDE,
        direccionGeograficaIDEExacta: dirExacta
      });
    }
  );

/*
export interface DireccionGeograficaFormInput {
  action: FormActionType;
  direccion_geografica: DireccionGeografica;
  direcciones_geografica_IDE: DireccionGeograficaIDE[];
  paises: Pais[];
  departamentos: Departamento[];
  localidades: Localidad[];
}

*/